import React from 'react';
const SearchBox=({searchChange})=>{
    return(
        <div className='pa2'>
        <input className='pa3 ba b--green bg-lightest-blue' type="search" placeholder="search robots" onChange={searchChange}/>
        </div>//onChange is an event when we search anything in the search box,can google
      
    );
}
export default SearchBox;